import axios from 'axios';

// Configure API base URL - use relative URLs for better deployment compatibility
const API_URL = process.env.REACT_APP_API_URL || '';

// Create axios instance
const api = axios.create({
  baseURL: API_URL
});

// Add request interceptor to include auth token and API key
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    console.log('API Request:', config.method.toUpperCase(), config.url);
    
    // Add Azure Functions API key only for production (not localhost)
    const apiKey = process.env.REACT_APP_AZURE_FUNCTIONS_API_KEY;
    const isProduction = !API_URL.includes('localhost') && !API_URL.includes('127.0.0.1');
    
    if (apiKey && isProduction) {
      config.headers['x-functions-key'] = apiKey;
      console.log('API key added to request (production)');
    } else if (!isProduction) {
      console.log('Local development - no API key needed');
    }
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      console.log('Token added to request:', token.substring(0, 20) + '...');
    } else {
      console.log('No token found in localStorage');
    }
    return config;
  },
  (error) => {
    console.error('Request interceptor error:', error);
    return Promise.reject(error);
  }
);

// Add response interceptor to handle auth errors
api.interceptors.response.use(
  (response) => {
    console.log('API Response:', response.status, response.config.url);
    return response;
  },
  (error) => {
    console.error('API Error:', error.response?.status, error.config?.url, error.response?.data);
    
    // Only handle 401 redirects for authenticated endpoints, not for login attempts
    if (error.response?.status === 401 && error.config?.url !== '/api/login') {
      console.log('401 error on protected endpoint - clearing auth data and redirecting to login');
      // Token is invalid, remove it
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    
    return Promise.reject(error);
  }
);

export default api;
